export const getMaxCardDigits = (digits) => {
  if (/^3[47]/.test(digits)) return 15;
  return 16;
};

export const getCardNumberMaxLength = (digits) => {
  const max = getMaxCardDigits(digits);
  return max + Math.floor((max - 1) / 4);
};

export const formatCardNumber = (raw) => {
  const allDigits = (raw || "").replace(/\D/g, "");
  const digits = allDigits.slice(0, getMaxCardDigits(allDigits));
  return digits.replace(/(\d{4})(?=\d)/g, "$1 ");
};

export const formatExpiry = (raw) => {
  const digits = (raw || "").replace(/\D/g, "").slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
};

export const formatCvv = (raw) => (raw || "").replace(/\D/g, "").slice(0, 4);

export const restoreCursor = (inputEl, formatted, digitsBeforeCursor) => {
  if (!inputEl) return;
  let pos = 0;
  let seen = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (seen >= digitsBeforeCursor) break;
    pos = i + 1;
    if (/\d/.test(formatted[i])) seen += 1;
  }
  try {
    inputEl.setSelectionRange(pos, pos);
  } catch (_) {}
};
